var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "#FFFFFF",
    className: "bcPlayButtonSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28a14 14 0 1 1 0-28 14 14 0 0 1 0 28zm3.64-21C15.34 7 14 8.9 14 8.9S12.67 7 10.36 7A4.27 4.27 0 0 0 6 11.16c0 4.04 4.95 7.9 7.2 9.58a1.36 1.36 0 0 0 1.6 0c2.25-1.68 7.2-5.54 7.2-9.57C22 8.86 20.05 7 17.64 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToFav);
export default __webpack_public_path__ + "static/media/addToFav.806ee282296d383a5b915be39619ff1a.svg";
export { ForwardRef as ReactComponent };